"use client";
import React from "react";
import Image from "next/image";
import PrimaryBtn from "@/components/PrimaryBtn";

import Images, { Icons } from "../assets/assets";

export default function GlobalRanking() {
  return (
    <section className="w-full bg-white">
      <div className="w-[calc(100vw-10%)] max-w-[2500px] mx-auto py-[70px] lg:py-[150px] flex flex-col xl:flex-row gap-[30px] justify-between">
        {/* Left copy */}
        <div className="w-full xl:w-[845px] flex flex-col gap-[30px] justify-center">
          <div className="flex flex-col gap-[15px]">
            <span className="text-[#00040b] text-[16px] uppercase">
              Global ranking
            </span>
            <h2 className="text-[length:var(--section-title)] font-[500] clash-font leading-[100%]">
              We lead the{" "}
              <span className="text-[#225BD4]">global rankings</span>
            </h2>
          </div>

          <p className="text-[#636364] text-[clamp(0.9375rem,0.4664rem+0.9815vw,2rem)] leading-[140%] max-w-[845px]">
            Our unmatched quality services are recognized by growing start-ups
            as well as Fortune 500 companies
          </p>

          <div>
            <PrimaryBtn
              text="Let’s Build Something Amazing"
              iconSrc={Icons?.chevron}
              dark={false}
              href={"/contact-us"}
            />
          </div>
        </div>

        {/* Right grid */}
        <div className="w-full xl:w-[845px] grid grid-cols-1 sm:grid-cols-2 border border-[#ECF0F6]">
          {/* Card 1 */}
          <div className="border-b sm:border-b border-r sm:border-r border-[#ECF0F6] bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand1}
                alt="gyggc"
                width={109}
                height={46}
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                className="h-[46px] max-w-[190px] object-contain w-auto"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  Ranked Among Top 10 Mobile App Developers
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  by appfutura.com - 2019
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="border-b sm:border-b border-[#ECF0F6] bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand2}
                alt="gyggc"
                width={109}
                height={46}
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                className="h-[46px] max-w-[190px] object-contain w-auto"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  Ranked Among Top iOS App Development Agencies
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  by businessofapps.com - 2020
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="border-b sm:border-b border-r sm:border-r border-[#ECF0F6] bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand3}
                alt="about-brand"
                width={109}
                height={46}
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                className="h-[46px] max-w-[190px] object-contain w-auto"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  Ranked Among Top 5 App Developers & Development
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  Companies in India - 2020
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="border-b sm:border-b border-[#ECF0F6] bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand4}
                alt="gyggc"
                width={109}
                height={46}
                className="h-[46px] max-w-[190px] object-contain w-auto"
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  #1 Magento Web Development Company
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  by extract.co - 2019
                </p>
              </div>
            </div>
          </div>

          {/* Card 5 */}
          <div className="border-r sm:border-r border-[#ECF0F6] bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand5}
                alt="gyggc"
                width={109}
                height={46}
                className="h-[46px] max-w-[190px] object-contain w-auto"
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  Ranked Among Top 5 App Developers & Development
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  Companies in India - 2020
                </p>
              </div>
            </div>
          </div>

          {/* Card 6 */}
          <div className="bg-white">
            <div className="px-10 py-9 flex flex-col items-center gap-6">
              <Image
                src={Images?.aboutBrand?.brand6}
                alt="gyggc"
                width={109}
                height={46}
                className="h-[46px] max-w-[190px] object-contain w-auto"
                sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              />

              <div className="text-center flex flex-col gap-2">
                <p className="text-[18px] leading-none text-[#00040b]">
                  Top 5 Mobile App Development Companies
                </p>
                <p className="text-[15px] leading-[140%] text-[#636364]">
                  by SiliconIndia - 2018
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
